import * as yup from 'yup';

const authSchema = yup.object({
  login: yup.string().required('Логин не указан'),
  password: yup.string().required('Пароль не указан'),
});

export default authSchema;
